













import Vue from "vue";
import ReportManagement from "@/components/templates/ReportManagement/index.vue";
import snackbar from "@/shared/snackbar";

export default Vue.extend({
  components: {
    ReportManagement,
  },
  methods: {
    getTemplates() {
      const { group_id } = this.$route.params;
      this.$store.dispatch("report/getTemplates", group_id);
    },
    getReportLabels() {
      const { group_id } = this.$route.params;
      this.$store.dispatch("report/getReportLabels", group_id);
    },
    handleOnCreate() {
      this.$store.dispatch("report/openTemplateModal");
    },
    handleOnDelete(templates: any) {
      const { group_id } = this.$route.params;
      const templateIds = templates.map((t: any) => t.id);
      let items = "";
      for (const v of templates) {
        items += `<br>${v.name}`;
      }
      this.$dialog.confirm({
        title: "テンプレートの削除",
        message: `本当に削除しますか？この操作は取り消せません。${items}`,
        confirmText: "テンプレートを削除する",
        cancelText: "キャンセル",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch("report/deleteTemplates", { reportId: group_id, templateIds })
          .then(() => {
            snackbar.success(this, { message: "テンプレートを削除しました。"});
          })
          .catch((err) => {
            snackbar.error(this, { message: `テンプレートを削除に失敗しました。:${err}`});
          });
        },
      });
    },
    handleOnUpdateGroupInfo() {
      this.$store.dispatch("report/openCreateReportGroupModal");
    },
  },
});
